// the PopupForm class activates an element to draw a popup window on top
// Designed for a form, but I guess it could be used with just regular html, as long as you have a cancel button

// Store the URL in the rel tag or the href tag

// Built to works with AjaxForm but not required.  Expects AjaxForm to be attached with the content_processor.

// Some noteable events that are fired: 
/*
 resize_popup_event_name: 'resize_popup', // Name of the event that fires to resize the popup
 close_popup_event_name: 'close_popup', // Name of the event to close the popup
 open_popup_event_name: 'open_popup', // Name of the event to open the popup
 popup_closed_event_name: 'popup_closed', // Name of the event that is fired after the popup is successfully closed
 popup_opened_event_name: 'popup_opened' // Name of the event that is fired after the popup is successfully opened. 
 */

var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.MooPopup = new Class({
    Implements: [Options, Events],
    close_form_function: null, // The function for the close event (so we can remove it)
    esc_test_bound: null, // the bound function for the keyup event
    popup_avialable: true, // Flag to prevent double-clicking from opening the form twice
    container: null, // The container

    options: {
        container_class: 'over_mask', // The class for the form container
        mask_options: {
            onShow: function () {
                this.element.setStyle('position', 'fixed');
            }
        },
        use_mask: true,
        popup_template_fields: {
            popup_wrapper_class: 'popup_wrapper',
            popup_container_class: 'popup_container', // The class for the container
            popup_close_container_top: false,
            popup_close_container_bottom: true,
            popup_close_content: "",
            popup_content_class: 'popup_content', // The class for the content 
            popup_content: ""
        },
        popup_close_template_fields: {
            popup_close_container_class: 'popup_close_container',
            popup_close_button_class: 'popup_close_button cancel',
            popup_close_button_content: ''
        },
        popup_template: "{{{popup_content}}}",
        popup_template_close: "",
        show_mask_immediately: true, // Set to false to show the mask after loading
        popup_id: 'popup_item', // ID to give the popup container so we can easily access it to close it.
        posting_data: null, // The posting data (query string) when getting the form
        cancel_selector: '.cancel', // The selector for any cancel buttons
        any_click_cancels: false, // Set to true to close the form on any click at the window level
        esc_closes: true, // Set to false to prevent the escape key from closing the popup
        close_anchor: '.close_anchor', // Apply this to an anchor to close the form but don't stop the event (i.e. a target _blank)
        content_processor: function () {}, // Function to process the content of the form once it's loaded
        event_type: 'click', // The event type to listen for.  Can be click, dblclick, keyup, etc.
        active_event_name: 'active',
        storage_name: 'popup_form',
        hidden_class: 'hidden',
        url: null, // If null, will use the rel tag or href tag
        onSuccess: function () {}, // Function to process after a successful form submission
        onOpen: function () {}, // Function to cass when a popup form is fired. Passed the event.
        onClose: function () {} // Function to call when the popup form is closed. Passed the resulting json.
    },
    initialize: function (item, op) {
        // Make sure we haven't processed this item yet
        var current_form = item.retrieve(this.options.storage_name);
        /* istanbul ignore if  */
        if (current_form) {
            return current_form;
        } else {
            item.store(this.options.storage_name, this);
        }
        this.setOptions(op);
        this.item = item;
        // Create the mask
        // Add a click event for the item
        item.addEvent(this.options.event_type, this.open_form.bind(this));

        this.close_form_function = function (e) {
            /* istanbul ignore if  */
            if (e && e.stop) {
                e.stop();
            }
            this.close_form(e);
        }.bind(this);

        // Popup Template
        var tm = new OCS.Classes.TemplateManager();
        tm.define_template('popup_template', this.options.popup_template);
        tm.define_template('popup_close_template', this.options.popup_template_close);

    },
    set_posting_data: function (data) {
        this.options.posting_data = data;
    },
    open_form: function (event) {
        if (event) {
            event.stop();
        }
        if (!this.popup_avialable) {
            return;
        }
        this.popup_avialable = false;
        /* istanbul ignore if  */
        if (this.options.onOpen) {
            this.options.onOpen(event);
        }
        this.fireEvent('open', [event, this]);
        if (this.options.use_mask) {
            this.mask = new Mask(null, this.options.mask_options);
            if (this.options.show_mask_immediately) {
                this.mask.show();
            }
        }
        this.get_container();
        if (this.options.popup_template_fields.popup_content !== "") {
            this.process_form(this.options.popup_template_fields.popup_content);
        } else {
            var url = this.options.url;
            if (!url) {
                url = this.item.get('rel');
            }
            // Adding functionality to check for the href tag
            if (!url) {
                url = this.item.get('href');
            }
            this.make_request(url);

        }

    },
    make_request: function (url) {
        if (url && typeof (url) !== "undefined" && url !== '') {
            var req = new Request({
                'url': url,
                'data': this.options.posting_data,
                onSuccess: this.process_form.bind(this),
            }).post();
        }
    },
    process_form: function (html) {
        this.set_popup_content(html);
        var tm = new OCS.Classes.TemplateManager();
        if (this.options.popup_template_fields.popup_close_content === "") {
            this.options.popup_template_fields.popup_close_content = tm.get_html('popup_close_template', this.options.popup_close_template_fields);
        }
        this.get_container();
        this.container.empty();
        this.container.appendHTML(tm.get_html('popup_template', this.options.popup_template_fields));

        this.process_form_content(this.container);
        this.fireEvent(this.options.active_event_name, this);
    },
    process_form_content: function (container) {
        container.getElements(this.options.cancel_selector).each(function (item) {
            item.addEvent('click', this.close_form_function);
        }, this);
        if (this.options.any_click_cancels && this.options.use_mask) {
            this.mask.addEvent('click', this.close_form_function);
        }
        if (this.options.esc_closes) {
            this.esc_test_bound = this.esc_test.bind(this);
            document.id(document.body).addEvent('keyup', this.esc_test_bound);
        }
        container.getElements(this.options.close_anchor).each(function (item) {
            // Don't use the close_formr_function here because we want the event to propogate
            item.addEvent('click', this.close_form.bind(this));
        }, this);
        container.getElements('form').each(this.store_data_into_form.bind(this));
        this.options.content_processor(container);
        // Move the document scroll to the top, saving the current scroll location
        this.saved_scroll = document.id(document.body).getScroll();
        document.id(document.body).scrollTo(0, 0);
        if (this.options.use_mask && this.mask) {
            this.mask.position();
            this.mask.show();
        }
    },
    esc_test: function (e) {
        if (e.key == 'esc') {
            this.close_form();
        }
    },
    store_data_into_form: function (form) {
        form.store('onSubmit', function () {
            /* istanbul ignore next */
            this.container.addClass(this.options.hidden_class);
        }.bind(this));
        form.store('onComplete', this.close_form.bind(this));
        form.store('processContent', this.process_form_content.bind(this));
    },
    get_container: function () {
        if (!this.container) {
            this.container = new Element('div', {
                'class': this.options.container_class,
                'id': this.options.popup_id,
                'name': this.options.popup_id
            }).inject(document.id(document.body));
        }
        return this.container;
    },
    set_popup_content: function (content) {
        this.options.popup_template_fields.popup_content = content;
    },
    close_form: function (json) {
        // Make sure we have a form
        /* istanbul ignore if  */
        if (!this.container) {
            return;
        }
        // If we receive a value 'redo' in the json, re-draw the form.
        if (json && json.redo) {
            this.container.removeClass(this.options.hidden_class);
        } else {
            // No redo, so goodbye to the form
            /* istanbul ignore if  */
            if (this.options.tips) {
                this.options.tips.hide();
            }
            this.container.dispose();
            this.container = null;
            /* istanbul ignore if  */
            if (typeOf(json) != 'event' && typeOf(json) != 'domevent' && this.options.onSuccess) {
                // Only fire success if this isn't the cancel event
                this.options.onSuccess(json);
                this.fireEvent('success', [json, this]);
            }
            if (this.options.use_mask) {
                this.mask.destroy();
            }
            this.popup_avialable = true;
            if (this.saved_scroll) {
                document.id(document.body).scrollTo(this.saved_scroll.x, this.saved_scroll.y);
            }
            if (this.options.any_click_cancels && this.options.use_mask) {
                this.mask.removeEvent('click', this.close_form_function);
            }
            /* istanbul ignore if  */
            if (this.options.onClose) {
                this.options.onClose(json);
            }
            this.fireEvent('close', [json, this]);
            if (this.esc_test_bound) {
                document.id(document.body).removeEvent('keyup', this.esc_test_bound);
            }
        }
    },
    destroy: function () {
        this.item.removeEvent(this.options.event_type, this.open_form.bind(this));
        this.item.store(this.options.storage_name, null);
        this.item = null;
        if (this.mask) {
            this.mask.destroy();
            this.mask = null;
        }
        if (this.container) {
            this.container.store(this.options.storage_name, null);
            this.container.destroy();
            this.container = null;
        }
    }
});
